import axios from 'axios';
import {actions} from '../reducers/OrderDetailsReducer';

export const CREATE_ORDER = '/orders/createEditOrder';
export const GET_ORDER_BY_ID = '/orders/getOrderByID';

export const createEditOrder = ({
                                  orderID,
                                  customers,
                                  usingLawyer,
                                  lawyerName,
                                  shumaForOrderCount,
                                  dueDate,
                                  responsibleUser,
                                  priceQuoteID,
                                  paid,
                                  totalPayment,
                                  contactID
                                }) => {
  const data = {
    orderID,
    customers,
    usingLawyer,
    lawyerName,
    shumaForOrderCount,
    dueDate,
    responsibleUser,
    priceQuoteID,
    paid: paid ? parseFloat(paid) : 0,
    totalPayment: totalPayment ? parseFloat(totalPayment) : 0,
    contactID: contactID ? parseFloat(contactID) : null,
  };

  return axios.post(CREATE_ORDER, data)
    .then(response => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error();

      const {orderID} = body;

      return orderID;
    });
};

export const getOrderByID = (orderID) => (dispatch) => {
  dispatch(actions.loadingOrderDetails({orderDetails: {}}));

  return axios.post(GET_ORDER_BY_ID, {orderID})
    .then(response => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error();

      dispatch(actions.fetchOrderDetails({orderDetails: body}));
    })
    .catch(error => {
      error.clientMessage = 'Can\'t get order data';
      dispatch(actions.catchError({error}));
    });
};
